<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-body">
					<p style="text-align: center;" class="display-1 text-info"><i class="fa fa-circle-question"></i></p>
					<span class="display-5">{{question}}</span>
				</div>
				<div class="modal-footer">
					<button *ngFor="let option of options" (click)="close.emit(option)" class="btn btn-{{option.class}}">
						<i class="{{option.icon}}"></i>{{option.text}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>